const actions = {
  FETCH_AUDITS_START: 'benefits_envelope_audit/fetch_start',
  FETCH_AUDITS_SUCCESS: 'benefits_envelope_audit/fetch_success',
  CLEAR_AUDITS: 'benefits_envelope_audit/clear_data',
};

export default actions;
